import React, { Component } from "react";
import PropTypes from "prop-types";
import { TextInput, DialogBox, DialogBoxFooterType, NoLink, ZeroToInfiniteGrid } from "~/core";
import { withEditableGrid } from "~/hocs";
import { messages } from "./../i18n-messages";
import classnames from "classnames";
import { createAddLinkLabelText, createAddEditModalTitle } from "~/i18n-messages";
const PROPS_SALES_PERSON_ID = "salespersonId";

class SalespersonID extends Component {
    static propTypes = {
        classNames: PropTypes.array,
        record: PropTypes.array,
        formatMessage: PropTypes.func,
        renderDeleteModal: PropTypes.func,
        toggleModal: PropTypes.func,
        onChange: PropTypes.func,
        onAdd: PropTypes.func,
        onEdit: PropTypes.func,
        onDelete: PropTypes.func,
        onAddOrEditItem: PropTypes.func,
        deleteItem: PropTypes.func,
        isEditing: PropTypes.bool,
        isDeleting: PropTypes.bool,
        editData: PropTypes.object,
        required: PropTypes.bool,
    };
    constructor(props) {
        super(props);
        this.state = {
            editingItem: false,
        };
    }

    onEdit = (record, index) => {
        const keysToUpdate = [PROPS_SALES_PERSON_ID];
        this.setState({ editingItem: true });
        this.props.onEdit({ record, index, keysToUpdate });
    };

    onAdd = () => {
        this.setState({ editingItem: false });
        this.props.onAdd();
    };

    renderAddEditModal = () => {
        const { formatMessage, isEditing, editData, onAddOrEditItem, onChange, toggleModal } =
            this.props;
        return (
            <DialogBox
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                action="save"
                isOpen={isEditing}
                actionDisabled={!editData[PROPS_SALES_PERSON_ID]}
                onAction={() => onAddOrEditItem()}
                onClose={() => toggleModal("isEditing", false)}
                title={createAddEditModalTitle(
                    this.state.editingItem,
                    formatMessage,
                    messages.salespersonID
                )}
                testId="salesperson-id-add-edit-modal"
            >
                <TextInput
                    tabIndex={0}
                    maxLength={50}
                    placeholderText={formatMessage(messages.salespersonID)}
                    labelText={formatMessage(messages.salespersonID)}
                    value={editData[PROPS_SALES_PERSON_ID] || ""}
                    onChange={(value) => onChange({ [PROPS_SALES_PERSON_ID]: value })}
                    containerClassNames={["salesperson-textbox"]}
                    autoFocus
                    required={this.props.required}
                    testId="salesperson-id-input"
                />
            </DialogBox>
        );
    };

    render() {
        const { record, formatMessage, renderDeleteModal, onDelete } = this.props;
        const addLinkClassNames = classnames("add-link-container", this.props.classNames);
        return (
            <div className="form-section-child-stretch mini-grid">
                {record && record.length > 0 && (
                    <ZeroToInfiniteGrid
                        records={record}
                        columns={{
                            [PROPS_SALES_PERSON_ID]: {
                                title: formatMessage(messages.salespersonID),
                            },
                        }}
                        className={"cell-stretch"}
                        onEdit={this.onEdit}
                        onDelete={(record, index) => onDelete({ record, index })}
                        showHeader={false}
                    />
                )}
                {this.renderAddEditModal()}
                {renderDeleteModal()}
                <div className={addLinkClassNames}>
                    <NoLink
                        className="add-link"
                        label={createAddLinkLabelText(formatMessage, messages.salespersonID)}
                        onClick={this.onAdd}
                    ></NoLink>
                </div>
            </div>
        );
    }
}

export default withEditableGrid(SalespersonID);
